import styles from "./Home.module.css";
import resume from "../../assets/KarissaPhillipsResume2026.pdf";

const Home = () => {
  return (
    <section className={styles.container} id="home">
      <div className={styles.name}>
        <span>Hi, I'm</span>
        <span>Karissa Phillips</span>
        <span>User Experience Engineer</span>
        <button
          id="desktop"
          type="submit"
          onClick={() => window.open(resume)}
          value="KarissaPhillipsResume"
        >
          View My Resume
        </button>
      </div>
      <div className={styles.imageWrapper}>
        <div className={styles.image}></div>
      </div>
      <button
        id="mobile"
        type="submit"
        onClick={() => window.open(resume)}
        value="KarissaPhillipsResume"
      >
        View My Resume
      </button>
    </section>
  );
};

export default Home;
